import { composeMap } from './compose-map';
import { resolveRow as resolveAgainstMap } from './resolver';
import { legacyMap } from './legacy';
import { coreEntries } from './entries';

export const composedMap = composeMap(coreEntries, legacyMap);

export function resolveRow(row) {
  return resolveAgainstMap(composedMap, row);
}
